import {
  generateJourneyId,
  getGlobalData,
  getJourneyId,
  getPdtRequestId,
  getRequestId,
  setSubPageName,
  setGlobalData,
} from './analytics-utils';

import { init, captureEvent } from './analytics';

import * as CONSTANTS from './analytics-constants';

export default {
  init,
  captureEvent,
  generateJourneyId,
  getJourneyId,
  getPdtRequestId,
  getRequestId,
  setGlobalData,
  getGlobalData,
  setSubPageName,
  ...CONSTANTS,
};
